module.exports = __webpack_public_path__ + "img/header-small.61f16887.svg";